import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_unified-calendar-app-2/artifacts/7wohqirg_Texto%20del%20pa%CC%81rrafo.jpeg";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#F4EFE4]">
      <nav className="sticky top-0 z-50 backdrop-blur-md bg-[#F4EFE4]/90 border-b border-[#E8DFD2]">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Amarme" className="h-10 w-10 rounded-full object-cover border border-[#B5704A]/20" />
            <div className="leading-none">
              <div className="brand-wordmark text-base text-[#3A2418]">AMARME</div>
              <div className="font-script text-xs text-[#B5704A] -mt-0.5">Skin studio</div>
            </div>
          </Link>
          <Link to="/" className="inline-flex items-center gap-1 text-sm text-[#6F5A4C] hover:text-[#B5704A]">
            <ArrowLeft className="w-4 h-4" /> Volver
          </Link>
        </div>
      </nav>

      <article className="max-w-3xl mx-auto px-6 py-16 text-[#3A2418]">
        <span className="label-eyebrow text-[#B5704A]">Legal</span>
        <h1 className="font-display text-5xl font-[300] mt-2 leading-tight" data-testid="privacy-title">
          Política de <span className="italic font-[500] text-[#B5704A]">privacidad</span>
        </h1>
        <p className="text-sm text-[#6F5A4C] mt-2">Última actualización: 27 de mayo de 2026</p>

        <div className="prose prose-stone mt-10 space-y-6 leading-relaxed">
          <p>
            En <strong>Amarme Skin Studio</strong> (en adelante "el estudio") respetamos tu privacidad y nos comprometemos a proteger tus datos personales. Esta política describe cómo recopilamos, usamos y protegemos tu información cuando visitas <strong>amarmeskin.cl</strong> o reservas un tratamiento con nosotras.
          </p>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">1. Datos que recopilamos</h2>
            <p>Cuando reservas una cita o completas tu ficha clínica, podemos recopilar:</p>
            <ul className="list-disc list-inside space-y-1 mt-2 text-[#3A2418]">
              <li>Datos de identificación: nombre, fecha de nacimiento, edad, género.</li>
              <li>Datos de contacto: teléfono (WhatsApp), correo electrónico, dirección, ciudad, contacto de emergencia.</li>
              <li>Datos clínicos: historial médico, alergias, medicamentos, condiciones de la piel, tratamientos previos.</li>
              <li>Datos de uso del sitio: cookies técnicas, fecha de reserva, tratamientos seleccionados.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">2. Finalidad del tratamiento de tus datos</h2>
            <ul className="list-disc list-inside space-y-1 text-[#3A2418]">
              <li>Gestionar tus reservas y agenda de tratamientos.</li>
              <li>Diseñar protocolos de cuidado facial personalizados y seguros para tu piel.</li>
              <li>Enviarte recordatorios y comunicaciones sobre tus citas vía WhatsApp.</li>
              <li>Mantener un registro clínico de tus sesiones.</li>
              <li>Mejorar nuestros servicios y atención.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">3. Base legal</h2>
            <p>
              El tratamiento de tus datos se realiza con tu consentimiento expreso conforme a la Ley Nº 19.628 de Chile sobre Protección de la Vida Privada. Los datos sensibles (información clínica) solo se procesan si has aceptado la declaración de consentimiento al completar tu ficha.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">4. Compartimos tus datos con terceros</h2>
            <p>Solo compartimos datos con proveedores que nos prestan servicios técnicos necesarios:</p>
            <ul className="list-disc list-inside space-y-1 mt-2 text-[#3A2418]">
              <li><strong>Google Calendar</strong>: para sincronizar tu cita en nuestra agenda profesional.</li>
              <li><strong>Meta (WhatsApp Business API)</strong>: para enviarte recordatorios de cita.</li>
              <li><strong>Emergent / Cloud Hosting</strong>: para alojar el sitio y base de datos.</li>
            </ul>
            <p className="mt-3">
              Nunca vendemos ni cedemos tus datos a terceros con fines comerciales.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">5. Conservación de los datos</h2>
            <p>
              Mantenemos tus datos mientras seas clienta activa y hasta 5 años después de tu última visita, salvo que solicites su eliminación.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">6. Tus derechos</h2>
            <p>En todo momento puedes:</p>
            <ul className="list-disc list-inside space-y-1 mt-2 text-[#3A2418]">
              <li>Acceder a los datos que tenemos sobre ti.</li>
              <li>Rectificar información inexacta.</li>
              <li>Solicitar la eliminación de tu ficha (derecho al olvido).</li>
              <li>Retirar tu consentimiento en cualquier momento.</li>
              <li>Oponerte al envío de comunicaciones de marketing.</li>
            </ul>
            <p className="mt-3">
              Para ejercer estos derechos escríbenos a <a className="text-[#B5704A] underline" href="https://wa.me/56973842894">+56 9 7384 2894</a> por WhatsApp.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">7. Seguridad</h2>
            <p>
              Implementamos medidas técnicas y organizativas para proteger tus datos contra acceso no autorizado. Las contraseñas y tokens viajan cifrados (HTTPS) y solo personal autorizado de Amarme Skin Studio accede a tus fichas clínicas.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">8. Cookies</h2>
            <p>
              Usamos cookies técnicas estrictamente necesarias para el funcionamiento del sitio (sesión, preferencias). No usamos cookies publicitarias de terceros.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">9. Cambios en esta política</h2>
            <p>
              Podremos actualizar esta política periódicamente. La fecha de la última actualización aparece al inicio de este documento.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">10. Contacto</h2>
            <p>
              <strong>Amarme Skin Studio</strong><br />
              WhatsApp: <a className="text-[#B5704A] underline" href="https://wa.me/56973842894">+56 9 7384 2894</a><br />
              Instagram: <a className="text-[#B5704A] underline" href="https://www.instagram.com/amarmeskin">@amarmeskin</a><br />
              Web: <a className="text-[#B5704A] underline" href="https://amarmeskin.cl">amarmeskin.cl</a>
            </p>
          </section>
        </div>
      </article>
    </div>
  );
}
